export const palette = {
    primary: {
        main: '#7C8CFF',
        light: '#9AA6FF',
        dark: '#5C6EE8',
        contrastText: '#111111',
    },
    navy: {
        main: '#172A3A',
        light: '#26405A',
        dark: '#0F1D28',
        contrastText: '#F5F5F2',
    },
    ink: {
        main: '#111827',
        light: '#1F2937',
        dark: '#0B0F19',
        contrastText: '#F5F5F2',
    },
    background: {
        default: '#F5F5F2',
        paper: '#FFFFFF',
    },
    text: {
        primary: '#111111',
        secondary: 'rgba(17, 17, 17, 0.62)',
        disabled: 'rgba(17, 17, 17, 0.38)',
    },
    divider: 'rgba(17, 17, 17, 0.1)',
    common: {
        black: '#111111',
        white: '#F5F5F2',
    },
    fog: 'rgba(245, 245, 242, 0.6)',
    lineOnDark: 'rgba(245, 245, 242, 0.14)',
};
